import { render, staticRenderFns } from "./ViCreateFeesType.vue?vue&type=template&id=579bcb6a"
import script from "./ViCreateFeesType.vue?vue&type=script&lang=js"
export * from "./ViCreateFeesType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports